import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { UnpaidChartersComponent } from './unpaid-charters.component';
import { UnpaidChartersRoutingModule } from './unpaid-charters-routing.module';
import { UnpaidChartersResolve } from './unpaid-charters.resolve';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    UnpaidChartersRoutingModule,
    MatDialogModule,
    LoadingModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatIconModule,
    MatTooltipModule,
  ],
  declarations: [UnpaidChartersComponent],
  entryComponents: [],
  exports: [UnpaidChartersComponent],
  providers: [UnpaidChartersResolve],
})
export class UnpaidChartersModule {}
